'use strict';

export default function setOffset(breakpoint = 0) {
    let $holder = $('.js-content-holder');

    $holder.each((idx, el) => {
        let $el = $(el),
            $children = $el.find('.js-content-element'),
            elementBreakpoint = parseInt($el.attr('data-bp')) || breakpoint,
            offsetValue = window.innerWidth < elementBreakpoint ? 0 : Math.max.apply(Math, $children.map((idx, el) => $(el).outerHeight()));

        $el.css({
            paddingBottom: offsetValue
        });
    });
}
